<template>
  <span :title="creditScore ? creditScore.credit_score_status : 'New Borrower'">
    {{ creditScore ? Math.round(creditScore.showing_score * 100) / 100 : "NB" }}
    <v-icon
      small
      color="error"
      v-if="
        creditScore && creditScore.credit_score < creditScore.previous_score
      "
    >
      arrow_downward
    </v-icon>
    <v-icon
      small
      color="success"
      v-else-if="
        creditScore && creditScore.credit_score > creditScore.previous_score
      "
    >
      arrow_upward
    </v-icon>
  </span>
</template>
<script>
  export default {
    props: ["creditScore"],
  };
</script>
